import React, { useState, useEffect, useMemo } from 'react';
// Third-party libraries
import { connect } from "react-redux"
// UI - Material UI
import { Grid } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import DataTable from 'react-data-table-component';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
// Local files
import TableFilterComponentOtherTransactions from '../../common/TableFilterComponentOtherTransactions'
import { ColumnsDetailOrder } from './ColumnsDetailOrder'
import { customStylePrincipalOrder } from '../../common/CommonStyles'
import { FormatNumberMXN } from "../../common/Utils";
import { ColumnsDetailComments } from './ColumnsDetailComments';

const MuiAccordion = withStyles({
    root: {
      "&$expanded": {
        margin: "auto",
        border: '1px solid rgba(125, 155, 193)',
      }
    },
    expanded: {}
  })(Accordion);

const OrderDetailComments = ({classes, data, filteredItems, setFilteredItems,  t, ...props}) => {
    // Filtering state
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [searchButton, setSearchButton] = useState(0);
    //Accodeon component
    const [showComponentGeneral, setShowComponentGeneral] = useState(true);
    const [showComponentDetail, setShowComponentDetail] = useState(true);
    // config of pagination for DataTable
    const paginationOptions = { 
        rowsPerPageText: t('commonMessages.rowsPerPage'), 
        rangeSeparatorText: t('common.to'), 
        selectAllRowsItem: true, 
        selectAllRowsItemText: t('common.all') 
    }

    // Handle to |Accordeon
    const toggleAcordionGeneral = () => {
        setShowComponentGeneral((prev) => !prev);
      };
    const toggleAcordionDetail = () => {
        setShowComponentDetail((prev) => !prev);
    };    


    //Search Actions
    const handleSearchFilter = () => {
        if(data.orderComments == undefined)
            return;
        
        const items = data.orderComments.filter(item =>
            item.row && item.row.toString().includes(filterText.toLowerCase())
            ||  item.orderCommentDate && item.orderCommentDate.toString().toLowerCase().includes(filterText.toLowerCase())
            || item.orderComment && item.orderComment.toString().toLowerCase().includes(filterText.toLowerCase())
        );
        setFilteredItems(items);
    }

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilteredItems(data.orderComments);
                setFilterText('');
            }
        }
        console.log('filteredItems',filteredItems)
        return <TableFilterComponentOtherTransactions
            onFilter={e => setFilterText(e.target.value)}
            onClear={handleClear}
            filterText={filterText}
            SearchFilter={handleSearchFilter}
            styles={classes.searchAlign}
            module='OrderDetailComments'
            allowTextFilter
            SearchButton={'Visible'}
            allowExportExcel={false}
            showComponentDetail={!showComponentDetail}
        />

    }, [filterText, searchButton, filteredItems,showComponentDetail]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <MuiAccordion  defaultExpanded={true} border={4} expanded={showComponentDetail}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                    style={{backgroundColor:"#789AC1", minHeight:"37px", height:"37px"}}
                    IconButtonProps={{ onClick:toggleAcordionDetail }} >
                    {subHeaderComponentMemo}
                </AccordionSummary>
                <AccordionDetails>
                    <Grid item xs={12} width="100%">
                        <DataTable
                            columns={ColumnsDetailComments(t)}
                            persistTableHead
                            data={filteredItems}
                            customStyles={customStylePrincipalOrder}
                            highlightOnHover
                            pointerOnHover
                            responsive
                            striped
                            pagination
                            paginationComponentOptions={paginationOptions}
                            noHeader
                            noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                            />
                    </Grid>
                </AccordionDetails>
            </MuiAccordion>
        </>
    )
}

const mapStateToProps = state => ({
    orderDetails: state.OrderReducer.OrderDetails,
})


const mapDispatchToProps = (dispatch) => {
    return {
        tokenExpired: () => dispatch({ type: "TOKEN_EXPIRED" })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailComments)
